import { styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { VFC } from 'react';
import { useEffect, useRef } from 'react';

import { DESKTOP_BREAKPOINT } from '~/constants';

/*
  Note: this is a temporary solution. PBS icon is taken from the markup and relocated
  to avoid losing event listener attached to it. Dispatching custom event prevents
  the tooltip from showing too early.
*/

const PbsIconRoot = styled('div')(({ theme }) => ({
  marginLeft: 'auto',

  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(6),
  },

  [theme.breakpoints.up(DESKTOP_BREAKPOINT)]: {
    marginLeft: 'auto',
  },

  [theme.breakpoints.up('lg')]: {
    marginLeft: theme.spacing(4),
  },

  [theme.breakpoints.up('xl')]: {
    marginLeft: theme.spacing(6),
  },
}));

const SHOW_PBSLITE_TOOLTIP_EVENT_NAME = 'show-pbslite-tooltip';
const SHOW_PBSLITE_TOOLTIP_TIMEOUT = 5000;
const STORAGE_PBSLITE_DONT_OPEN_KEY = 'NHeaderSponsor-dont-open';

const relocateElement = (element: HTMLElement, target: HTMLElement) => {
  const elementParent = element.parentElement;
  elementParent?.removeChild(element);
  target.append(element);
};

const shouldOpenTooltip = () => {
  try {
    return sessionStorage.getItem(STORAGE_PBSLITE_DONT_OPEN_KEY) === null;
  } catch {
    return true;
  }
};

export const PbsIcon: VFC = () => {
  const ref = useRef<HTMLDivElement>(null);
  const { getTestId } = useTestId();

  useEffect(() => {
    const pbsIcon = document.querySelector<HTMLDivElement>('.js-header-sponsor');

    if (pbsIcon && ref.current) {
      relocateElement(pbsIcon, ref.current);
      pbsIcon.classList.remove('pbs-hidden');

      setTimeout(() => {
        if (shouldOpenTooltip()) {
          window.dispatchEvent(new CustomEvent(SHOW_PBSLITE_TOOLTIP_EVENT_NAME));
        }
      }, SHOW_PBSLITE_TOOLTIP_TIMEOUT);
    }
  }, []);

  return (
    <PbsIconRoot
      ref={ref}
      data-testid={getTestId('pbs-icon')}
    />
  );
};
